 import { AjaxPost } from "../../../Services/index";

export class ItemListModels {
    public SelectedItem: KnockoutObservable<any> = ko.observable(null);
    public SupplyLists: KnockoutObservableArray<any> = ko.observableArray([]);

    public AddToList = (product, vm) => {
        
        if (!product)
            return;
                       
        let self = vm;
        self.SelectedItem(product);





        let listRecNo = 0;

        function AddToList(itemToAdd) {
        
            return new Promise((resolve, reject) => {
                return new AjaxPost({
                    endpoint: '/ShoppingCart/AddItemToSupplyList',
                    payload: JSON.stringify(ko.toJS(itemToAdd)),
                    cbFunction: function (response) {
                        if (!response)
                            return;

                        let error = response.split(':')[0] === 'Error',
                            msgBody = error ? response : response.split(':')[1];

                        $('#add-to-new-list-button').hide();

                        resolve(response);
                    },

                    errFunction: function (err) {

                        reject(err);
                    }
                });
            }).then(() => {                
                $("#add-to-list-modal").modal('hide');
                $("#create-new-list-modal").modal('hide');
            })
        }


        $('#new-list-name').val("");

       
        console.log("AddToList data: ", { product, vm });

        let init = true;
       
        
        $(document).on('click', '#add-to-list-button', function () {        
            
            
            let DefaultUMDescription = $('#DefaultUMDescription').val(),
                SelectedList = $('#SelectedList').val();

            let payload = {
                SupplyListRecNo: SelectedList === "null" ? null : SelectedList,
                ItemID: product.ItemID,
                DefaultUMDescription: DefaultUMDescription,
                ItemGroupRecNo: product.ItemGroupRecNo
            }

            if (init) {
                if (SelectedList === "null") {
                    // handle this later.
                }

                AddToList(payload);
                init = false;
            }
        });
        
        $('#create-new-list-button').click(function () {
            
            let DefaultUMDescription = $('#DefaultUMDescription').val();
            let desc = product.Description + " - " || "";
            let itemToAddDesc = desc + "(Default UoM: " + DefaultUMDescription.toString().trim() + ")";

            $('#selected-item').text(itemToAddDesc);
            $('#add-to-list-modal').modal('hide');
            
            $("#new-list-err").empty();
            $('#create-new-list-modal').modal('show');

            $('#create-new-list-back').show();
            $('#add-to-new-list-button').click(function () {
                
                let payload = {
                    SupplyListRecNo: listRecNo,
                    ItemID: product.ItemID,
                    DefaultUMDescription: DefaultUMDescription.toString().trim(),
                    ItemGroupRecNo: product.ItemGroupRecNo
                }

                if (init) {
                    AddToList(payload);
                    init = false;
                }

            });

        });

        var hasAnySupplyListItems = $("#hdn_HasAnySupplyListItems").val() == "True" ? true : false;                                
        if (!hasAnySupplyListItems) { // Account has no supply list
            $('#create-new-list-modal').modal('show');          
            return;
        }
        $('#add-to-list-modal').modal('show');
        
    };
    public CreateNewList = (listname: string, vm) => {
        let self = vm;
        
        return new Promise((resolve, reject) => {

            $('#create-new-list-modal').on('hidden.bs.modal', () => {
                
                $('#add-to-list-modal').modal('show');
                $("#SelectedList option:last").attr("selected", "selected");
            })

            return new AjaxPost({
                endpoint: '/ShoppingCart/CreateSupplyList',
                payload: JSON.stringify({ SupplyListName: listname }),
                cbFunction: function (response) {
                    if (!response)
                        return;

                    let success = response.split(':')[0] === 'Success',
                        error = response.split(':')[0] === 'Error',
                        msgBody = error ? response : response.split(':')[1];


                    if (success) {

                        
                        let SupplyListRecNo = response.split(':')[2];

                        let listObj = {
                            SupplyListRecNo: parseInt(SupplyListRecNo),
                            Display: listname.toString().trim()
                        };

                        console.debug("New list object: ", listObj);

                        self.SupplyLists.push(listObj);
                        self.SupplyLists.valueHasMutated();
                        $('#create-new-list-modal').modal('hide');

                        

                        //append to our dropdown if it did not already exist                        
                        //this should be captured in an event listener and responded to by the model instead of right here                        
                        var optionExists = ($('#SelectedList option[value=' + SupplyListRecNo + ']').length > 0);
                        if (!optionExists) {                            
                            $('#SelectedList').append("<option value='" + SupplyListRecNo + "'>" + listname.toString().trim() + "</option>");
                        }
                        if ($("#hdn_HasAnySupplyListItems").length > 0)
                        {                            
                            var HasAnySupplyListItems = $('#SelectedList option').length > 0 ? "True": "False";
                            $("#hdn_HasAnySupplyListItems").val(HasAnySupplyListItems);
                        }
                                                                        
                    } else {
                        console.error("CreateSupplyList error: ", msgBody);
                        $("#new-list-err").text("An error occured. Our tech team has been notified.");
                    }

                    resolve(response);
                },

                errFunction: function (err) {

                    reject(err);
                }
            });
        });

    };
}